import { Injectable, Inject } from '@angular/core';
import { HttpService } from '../../http.service';
import { Tier } from '../../models/tier';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { BaseService } from '../../base.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class TiersService extends BaseService
{
	private http: HttpService;
	private api: string;

	constructor(http: HttpService)
	{
		super();

		this.http = http;
		this.api = environment.api_url;
	}

	public getTiers(): Promise<Tier[]>
	{
		return this.http
			.get(this.api + 'tiers')
			.toPromise()
			.then(response => response.json().data as Tier[])
			.catch(this.handleError);
	}

	public getTierById(id: number): Promise<Tier>
	{
		return this.http
			.get(this.api + 'tiers/' + id)
			.toPromise()
			.then(response => response.json().data as Tier)
			.catch(this.handleError);
	}

	public removeTier(id: number): Promise<null>
	{
		return this.http
			.delete(this.api + 'tiers/' + id)
			.toPromise()
			.then(response => null)
			.catch(this.handleError);
	}

	public updateTier(tier: Tier): Promise<Tier>
	{
		return this.http
			.put(this.api + 'tiers/' + tier.id, JSON.stringify(tier))
			.toPromise()
			.then(response => response.json().data as Tier)
			.catch(this.handleError);
	}

	public storeTier(tier: Tier): Promise<Tier>
	{
		return this.http
			.post(this.api + 'tiers', JSON.stringify(tier))
			.toPromise()
			.then(response => response.json().data as Tier)
			.catch(this.handleError);
	}
}



// WEBPACK FOOTER //
// ./src/app/tiers/services/tiers.service.ts